import { render, staticRenderFns } from "./onlearn.vue?vue&type=template&id=2a54ff2d&scoped=true"
import script from "./onlearn.vue?vue&type=script&lang=js"
export * from "./onlearn.vue?vue&type=script&lang=js"
import style0 from "./onlearn.vue?vue&type=style&index=0&id=2a54ff2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a54ff2d",
  null
  
)

export default component.exports